// extracted by css-extract-rspack-plugin
export default {"section":"_e1cdfe0a","header":"_e9a3cf3c"};